import React from 'react';
import background from '../../assets/ask-nearspace.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class AskNearspace extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="How do scientists measure Earth's vital signs?"
        
        
        background={background}
     />
  
  );
 }
}   

export default AskNearspace;